// @ts-nocheck
/* eslint-disable */
import * as types from 'appRedux/actions/management_dashboard';
import { TimeUnit, subTime } from 'utils/dateUtils';

const widgets = [
  'projects',
  'contractValue',
  'cashFlow',
  'costs',
  'revenue',
  'variations',
  'workInProgressAnalysis',
];

const current = new Date();
const lastSixMonthDate = subTime(current, 6, TimeUnit.MONTHS);
const lastMonthDate = subTime(current, 1, TimeUnit.MONTHS);

function getWidgetHeight(widgetName) {
  if (
    widgetName === 'cashFlow' ||
    widgetName === 'costs' ||
    widgetName === 'revenue' ||
    widgetName === 'variations' ||
    widgetName === 'workInProgressAnalysis'
  ) {
    return 3;
  }

  if (widgetName === 'projects') {
    return 2;
  }

  return 1;
}

const initialState = {
  loader: false,
  showWidgetsModal: false,

  filterModal: {
    show: false,
    title: '',
  },
  projectsFilterModal: {
    show: false,
    fields: {
      contact_sum: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      // budget_cost: {
      //   checked: false,
      //   more_than: '',
      //   less_than: '',
      // },
      monthly_construction_budget_cost: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      monthly_claim_forecast: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      submitted_claim: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      assessed_claim: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      forecasted_gross_profit: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      forecasted_gross_margin: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      budgeted_gross_profit: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      budgeted_gross_margin: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      actual_gross_profit: {
        checked: false,
        more_than: '',
        less_than: '',
      },
      actual_gross_margin: {
        checked: false,
        more_than: '',
        less_than: '',
      },
    },
  },
  // showProjectsFilterModal: false,
  userPreferenceId: null,
  layout: widgets.map((widgetName, i) => ({
    x: (i * 6) % 12,
    y: 0,
    w:
      widgetName === 'projects' || widgetName === 'workInProgressAnalysis'
        ? 12
        : 6,
    h: getWidgetHeight(widgetName),
    minW: 6,
    minH:
      widgetName === 'cashFlow' ||
      widgetName === 'costs' ||
      widgetName === 'revenue' ||
      widgetName === 'variations'
        ? 2
        : getWidgetHeight(widgetName),
    i: widgetName,
  })),
  widgets: {
    projects: { added: true },
    workInProgressAnalysis: { added: true },
    contractValue: {
      added: true,
    },
    cashFlow: {
      added: true,
      chart: 'line',
      fields: [
        {
          label: 'Construction Budget Cost',
          value: 'construction_budget_cost',
          color: '#233759',
          checked: true,
        },
        {
          label: 'Construction Budget Claim',
          value: 'construction_budget_claim',
          color: '#f27921',
          checked: true,
        },
        {
          label: 'Tracked Cost',
          value: 'tracked_cost',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Approved Claim',
          value: 'approved_claim',
          color: '#60911d',
          checked: true,
        },
      ],
    },
    revenue: {
      added: true,
      chart: 'bar',
      fields: [
        {
          label: 'Construction Budget Claim',
          value: 'construction_budget_claim',
          color: '#233759',
          checked: true,
        },
        {
          label: 'Submitted Contract Claim',
          value: 'submitted_contract_claim',
          stackId: 'a',
          color: '#f27921',
          checked: true,
        },
        {
          label: 'Submitted Variation Claim',
          value: 'submitted_variation_claim',
          stackId: 'a',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Approved Contract Claim',
          value: 'approved_contract_claim',
          stackId: 'b',
          color: '#60911d',
          checked: true,
        },
        {
          label: 'Approved Variation Claim',
          value: 'approved_variation_claim',
          stackId: 'b',
          color: '#8dc641',
          checked: true,
        },
      ],
    },
    costs: {
      added: true,
      chart: 'bar',
      fields: [
        {
          label: 'Construction Budget Cost',
          value: 'construction_budget_cost',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Actual Contract Cost',
          value: 'actual_contract_cost',
          stackId: 'a',
          color: '#60911d',
          checked: true,
        },
        {
          label: 'Actual Variation Cost',
          value: 'actual_variation_cost',
          stackId: 'a',
          color: '#8dc641',
          checked: true,
        },
      ],
    },
    variations: {
      added: true,
      chart: 'line',
      fields: [
        {
          label: 'Submitted Variation Value',
          value: 'submitted_variation_value',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Approved Variation Value',
          value: 'approved_variation_value',
          color: '#60911d',
          checked: true,
        },
        {
          label: 'Not Proceeded Variation Value',
          value: 'not_proceeded_variation_value',
          color: '#8dc641',
          checked: true,
        },
      ],
    },
  },
  filter: {
    state: [],
    segment: [],
    subSegment: [],
    risk: [],
    assignee: [],
  },
  filterByDate: {
    startDate: subTime(new Date(), 1, TimeUnit.MONTHS),
    endDate: new Date(),
  },
  report: {
    basicInfo: {},
    contractValue: {},
    projects: [],
    cashFlow: [],
    costs: [],
    variations: [],
    revenue: [],
  },
};

function managementDashboardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.ADD_WIDGET:
      return addWidget(state, action);

    case types.REMOVE_WIDGET:
      return removeWidget(state, action);

    case types.CHANGE_LAYOUT:
      return {
        ...state,
        layout: action.payload.layout,
      };

    case types.OPEN_WIDGETS_MODAL:
      return {
        ...state,
        showWidgetsModal: true,
      };

    case types.CLOSE_WIDGETS_MODAL:
      return {
        ...state,
        showWidgetsModal: false,
      };

    case types.OPEN_FILTER_MODAL:
      return {
        ...state,
        filterModal: {
          show: true,
          title: action.payload.title,
        },
      };

    case types.CLOSE_FILTER_MODAL:
      return {
        ...state,
        filterModal: {
          show: false,
          title: '',
        },
      };

    case types.OPEN_PROJECTS_FILTER_MODAL:
      return {
        ...state,
        projectsFilterModal: {
          ...state.projectsFilterModal,
          show: true,
        },
      };

    case types.CLOSE_PROJECTS_FILTER_MODAL:
      return {
        ...state,
        projectsFilterModal: {
          ...state.projectsFilterModal,
          show: false,
        },
      };

    case types.UPDATE_FORM_INPUT:
      return upateFormInput(state, action);

    case types.UPDATE_FORM_CHECKBOX:
      return upateFormCheckbox(state, action);

    case types.FILTER_PROJECTS_WIDGET:
      return filterProjectsWidget(state);

    case types.RESET_PROJECTS_FILTER_FIELDS:
      return resetProjectsFilterFields(state);

    case types.FILTER_WIDGETS:
      return filterWidgets(state, action);

    case types.FILTER_WIDGETS_BY_DATE:
      return filterWidgetsByDate(state, action);

    case types.SELECT_CHART:
      const { widget, chart } = action.payload;
      return {
        ...state,
        widgets: {
          ...state.widgets,
          [widget]: {
            ...state.widgets[widget],
            chart,
          },
        },
      };

    case types.SELECT_WIDGET_FIELD:
      return selectWidgetField(state, action);

    // case types.FILTER_WIDGETS_BY_DATE:
    //   return {
    //     ...state,
    //     filter: {
    //       startDate: action.payload.startDate,
    //       endDate: action.payload.endDate,
    //     },
    //   };

    case types.GET_DASHBOARD_REPORTS_REQUEST:
      return {
        ...state,
        loader: true,
        userPreferenceId: null,
      };

    case types.GET_DASHBOARD_REPORTS_SUCCESS:
      return getDashboardReportsSuccess(state, action);

    case types.SET_USER_PREFERENCE:
      return setUserPreference(state, action);

    case types.CLEAR_REDUCER:
      return initialState;

    default: {
      return state;
    }
  }
}

const addWidget = (state, action) => {
  const {
    payload: { widgetName },
  } = action;

  const maxValY = Math.max(...state.layout.map((item) => item.y), 0);
  return {
    ...state,
    layout: state.layout.concat({
      x: (state.layout.length * 6) % 12,
      y: maxValY + 1,
      w: widgetName === 'projects' ? 12 : 6,
      h: getWidgetHeight(widgetName),
      minW: 6,
      minH:
        widgetName === 'cashFlow' ||
        widgetName === 'costs' ||
        widgetName === 'revenue' ||
        widgetName === 'variations'
          ? 2
          : getWidgetHeight(widgetName),
      i: widgetName,
    }),
    widgets: {
      ...state.widgets,
      [widgetName]: {
        ...state.widgets[widgetName],
        added: true,
      },
    },
  };
};

const removeWidget = (state, action) => {
  const {
    payload: { widgetName },
  } = action;
  return {
    ...state,
    layout: state.layout.filter((item) => item.i !== widgetName),
    widgets: {
      ...state.widgets,

      [widgetName]: {
        ...state.widgets[widgetName],
        added: false,
      },
    },
  };
};

const selectWidgetField = (state, action) => {
  const {
    payload: { widget, fields },
  } = action;

  return {
    ...state,

    widgets: {
      ...state.widgets,

      [widget]: {
        ...state.widgets[widget],
        fields: state.widgets[widget].fields.map((field) =>
          fields.includes(field.value)
            ? {
                ...field,
                checked: true,
              }
            : {
                ...field,
                checked: false,
              },
        ),
      },
    },
  };
};

const getDashboardReportsSuccess = (state, action) => {
  const {
    payload: { basic_info, contract_value, projects, time_data },
  } = action;

  return {
    ...state,
    loader: false,
    report: {
      ...state.report,
      masterProjects: projects,
      projects,
      basicInfo: basic_info,
      contractValue: contract_value,

      cashFlow: time_data.map(
        ({
          date,
          forecast_cost,
          forecast_claim,
          tracked_cost,
          approved_claim,
        }) => ({
          date,
          forecast_cost,
          forecast_claim,
          tracked_cost,
          approved_claim,
        }),
      ),
      costs: time_data.map(
        ({
          date,
          forecast_cost,
          actual_contract_cost,
          actual_variation_cost,
        }) => ({
          date,
          forecast_cost,
          actual_contract_cost,
          actual_variation_cost,
        }),
      ),
      revenue: time_data.map(
        ({
          date,
          forecast_claim,
          submitted_contract_claim,
          approved_contract_claim,
          submitted_variation_claim,
          approved_variation_claim,
        }) => ({
          date,
          forecast_claim,
          submitted_contract_claim,
          approved_contract_claim,
          submitted_variation_claim,
          approved_variation_claim,
        }),
      ),
      variations: time_data.map(
        ({
          date,
          submitted_variation_value,
          approved_variation_value,
          not_proceeded_variation_value,
        }) => ({
          date,
          submitted_variation_value,
          approved_variation_value,
          not_proceeded_variation_value,
        }),
      ),
    },
  };
};

const filterProjectsWidget = (state) => {
  const {
    projectsFilterModal: { fields },
  } = state;
  const selectedFields = Object.keys(fields).filter(
    (field) => fields[field].checked,
  );

  const filteredProjects =
    state.report.masterProjects &&
    state.report.masterProjects.filter((project) =>
      selectedFields.every((field) => {
        if (+fields[field].more_than > 0 && +fields[field].less_than > 0) {
          return (
            project[field] >= +fields[field].more_than &&
            project[field] <= +fields[field].less_than
          );
        }

        if (+fields[field].more_than > 0 && +fields[field].less_than <= 0) {
          return project[field] >= +fields[field].more_than;
        }

        if (+fields[field].less_than > 0 && +fields[field].more_than <= 0) {
          return project[field] <= +fields[field].less_than;
        }
      }),
    );

  return {
    ...state,
    projectsFilterModal: {
      ...state.projectsFilterModal,
      show: false,
    },
    report: {
      ...state.report,
      projects: filteredProjects,
    },
  };
};

const resetProjectsFilterFields = (state) => {
  return {
    ...state,
    projectsFilterModal: {
      ...state.projectsFilterModal,
      fields: {
        contact_sum: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        // budget_cost: {
        //   checked: false,
        //   more_than: '',
        //   less_than: '',
        // },
        monthly_construction_budget_cost: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        monthly_claim_forecast: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        submitted_claim: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        assessed_claim: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        forecasted_gross_profit: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        forecasted_gross_margin: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        budgeted_gross_profit: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        budgeted_gross_margin: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        actual_gross_profit: {
          checked: false,
          more_than: '',
          less_than: '',
        },
        actual_gross_margin: {
          checked: false,
          more_than: '',
          less_than: '',
        },
      },
    },
  };
};

const upateFormInput = (state, action) => {
  const {
    payload: { field, name, value },
  } = action;
  return {
    ...state,
    projectsFilterModal: {
      ...state.projectsFilterModal,
      fields: {
        ...state.projectsFilterModal.fields,
        [field]: {
          ...state.projectsFilterModal.fields[field],
          [name]: value,
        },
      },
    },
  };
};

const upateFormCheckbox = (state, action) => {
  const {
    payload: { field, checked },
  } = action;

  return {
    ...state,
    projectsFilterModal: {
      ...state.projectsFilterModal,
      fields: {
        ...state.projectsFilterModal.fields,
        [field]: {
          ...state.projectsFilterModal.fields[field],
          checked,
        },
      },
    },
  };
};
const filterWidgets = (state, action) => {
  const {
    payload: { type, values },
  } = action;

  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: values.filter((value) => value !== 'all'),
    },
  };
};

const filterWidgetsByDate = (state, action) => {
  const {
    payload: { startDate, endDate },
  } = action;
  return {
    ...state,
    filterByDate: {
      startDate,
      endDate,
    },
  };
};

const setUserPreference = (state, action) => {
  if (Object.keys(action.payload).length > 0) {
    const {
      payload: { id, layout, widgets },
    } = action;

    if (layout && widgets) {
      return {
        ...state,
        layout,
        widgets,
        userPreferenceId: id,
      };
    }
  }
  return state;
};

export default managementDashboardReducer;
